<pg-home-section-5>
  <section id="home-section-5">
    <img src={ornament5} alt="" class="ornament-5">
    <header>
      <h2>Redes Sociais</h2>
    </header>
    <div class="container">
      <a href="https://www.linkedin.com/company/vlgcorporate/" alt="Linkedin" target="_blank" class="item"><i class="icon-linkedin"></i></a>
      <a href="https://www.instagram.com/vlgcorporate/" alt="Instagram" target="_blank" class="item"><i class="icon-instagram"></i></a>
      <a href="https://www.facebook.com/vlgcorporate/" alt="Facebook" target="_blank" class="item"><i class="icon-facebook"></i></a>
    </div>
  </section>

  <script>
    import './pg-home-section-5.scss'

    import ornament5 from '../../media/home-ornaments/home-1.svg'

    export default {
      ornament5,
    }
  </script>
</pg-home-section-5>
